import { render, staticRenderFns } from "./FogoNightlyBanner.vue?vue&type=template&id=40f63fa6&scoped=true"
import script from "./FogoNightlyBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./FogoNightlyBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FogoNightlyBanner.vue?vue&type=style&index=0&id=40f63fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f63fa6",
  null
  
)

export default component.exports